module.exports = "<button (click)=\"openSidenav.emit()\" class=\"button\" fxHide.gt-sm mat-icon-button>\n  <mat-icon>menu</mat-icon>\n</button>\n"